import { IdeaAccessors, w2d2dApiClient } from "../../../../w2d2d-api-client"
import { Dispatch, SetStateAction, useCallback, useEffect, useMemo, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom";
import { W2d2dNavigation } from "../../../../W2d2dNavigation.tsx";
import { FormStep, StepForm } from "../../../../../appfw/ui/forms/StepForm.tsx";
import DateChooserStep from "./DateChooserStep.tsx";
import IdeaEditStep from "./IdeaEditStep.tsx";
import AudienceChooserStep from "./AudienceChooserStep.tsx";
import { useIdeasControl } from "../../../hooks/useIdeasControl";

export interface IdeaDraft {
    readonly id?: string;
    readonly title: string;
    readonly description?: string;
    readonly startsAt: Date;
    readonly duration: number;
    readonly accessors: IdeaAccessors;
}

export interface IdeaEditStepProps {
    readonly control: [IdeaDraft, Dispatch<SetStateAction<IdeaDraft>>],
}

const buildIdeaDraft = (): IdeaDraft => {
    let startsAt = new Date()
    if (startsAt.getHours() < 19) {
        startsAt.setHours(19, 0, 0, 0)
    } else {
        startsAt.setHours(startsAt.getHours(), 0, 0, 0)
    }
    return {
        title: "",
        description: "",
        startsAt: startsAt,
        duration: 2,
        accessors: { network: false, },
    }
}

export default function EditIdeaPage({ ideaDraft = buildIdeaDraft() }) {

    const navigate = useNavigate()
    const location = useLocation()
    const { updateIdeaById } = useIdeasControl()

    const control = useState<IdeaDraft>(ideaDraft)
    const [idea] = control

    const [connections, setConnections] = useState<undefined | string[]>()

    const handleFinish = useCallback(async (cancel: boolean) => {
        if (!cancel) {

            let userIds = idea.accessors.userIds
            let request = {
                ...idea,
                endsAt: new Date(idea.startsAt.getTime() + 1000 * 60 * 60 * idea.duration),
                accessors: {
                    ...idea.accessors,
                    userIds: userIds, // if network is checked, users will be ignored
                }
            }

            let _id = idea.id
            if (idea.id) {
                await w2d2dApiClient.updateIdea({
                    id: idea.id,
                    ...request,
                })
            } else {
                const newIdea = await w2d2dApiClient.newIdea(request)
                _id = newIdea.id
            }

            if (_id) {
                await updateIdeaById(_id)
            }
        }

        W2d2dNavigation.ideas.navigate(navigate, location)
    }, [idea, navigate, location, updateIdeaById])

    // TODO: use hook?
    useEffect(() => {
        let active = true
        w2d2dApiClient.getConnections()
            .then((response) => {
                if (active) {
                    setConnections(response.connections)
                }
            })
        return () => {
            active = false
        }
    }, [])

    const formSteps: FormStep<IdeaDraft>[] = useMemo(() => [
        {
            element: <DateChooserStep control={control} />,
            text: "Wann",
        }, {
            element: <IdeaEditStep control={control} />,
            text: "Idee",
            nextEnabled: form => {
                return form.title.trim().length > 0
            },
        }, {
            element: <AudienceChooserStep control={control} connections={connections || []} />,
            text: "Wer",
        },
    ], [idea, connections, control])

    if (connections == undefined) {
        // TODO: loading indicator?
        return null
    }

    return <StepForm
        steps={formSteps}
        form={idea}
        finishText={idea.id ? "Aktualisieren" : "Erstellen"}
        finish={handleFinish}
    />
}
